{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "لقد تجاوزت الحد الأقصى للمحادثات. تسمح خطة Hacker بـ 500 محادثة فقط.",
      "INBOXES": "لقد تجاوزت الحد الأقصى لصناديق الوارد. تدعم خطة Hacker الدردشة المباشرة على الموقع فقط. تتطلب صناديق الوارد الإضافية مثل البريد الإلكتروني وWhatsApp وغيرها خطة مدفوعة.",
      "AGENTS": "لقد تجاوزت الحد الأقصى للوكلاء. تسمح خطة Hacker بوكيلين فقط.",
      "NON_ADMIN": "يرجى التواصل مع المسؤول لترقية الخطة ومواصلة استخدام جميع الميزات."
    },
    "TITLE": "إعدادات الحساب",
    "SUBMIT": "تحديث الإعدادات",
    "BACK": "العودة",
    "DISMISS": "تجاهل",
    "UPDATE": {
      "ERROR": "تعذر تحديث الإعدادات، الرجاء المحاولة مرة أخرى!",
      "SUCCESS": "تم تحديث إعدادات الحساب بنجاح"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "حذف حسابك",
      "NOTE": "بمجرد حذف حسابك، سيتم حذف جميع بياناتك.",
      "BUTTON_TEXT": "حذف حسابك",
      "CONFIRM": {
        "TITLE": "حذف الحساب",
        "MESSAGE": "حذف حسابك إجراء لا يمكن التراجع عنه. أدخل اسم حسابك أدناه لتأكيد رغبتك في حذفه نهائياً.",
        "BUTTON_TEXT": "حذف",
        "DISMISS": "إلغاء",
        "PLACE_HOLDER": "يرجى كتابة {accountName} للتأكيد"
      },
      "SUCCESS": "تم وضع علامة على الحساب للحذف",
      "FAILURE": "تعذر حذف الحساب، حاول مرة أخرى!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "من المقرر حذف هذا الحساب في {deletionDate}. طلب هذا أحد المسؤولين. يمكنك إلغاء الحذف قبل هذا التاريخ.",
        "MESSAGE_INACTIVITY": "من المقرر حذف هذا الحساب في {deletionDate} بسبب عدم نشاطه. يمكنك إلغاء الحذف قبل هذا التاريخ.",
        "CLEAR_BUTTON": "إلغاء الحذف المجدول"
      }
    },
    "FORM": {
      "ERROR": "الرجاء إصلاح الأخطاء في النموذج",
      "GENERAL_SECTION": {
        "TITLE": "الإعدادات العامة",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "معرف الحساب",
        "NOTE": "هذا المعرف مطلوب إذا كنت بصدد بناء تكامل على API"
      },
      "NAME": {
        "LABEL": "اسم الحساب",
        "PLACEHOLDER": "اسم الحساب الخاص بك",
        "ERROR": "الرجاء إدخال اسم حساب صحيح"
      },
      "LANGUAGE": {
        "LABEL": "لغة الموقع",
        "PLACEHOLDER": "اسم الحساب الخاص بك",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "نطاق البريد الإلكتروني الوارد",
        "PLACEHOLDER": "النطاق الذي ستتلقى عليه رسائل البريد الإلكتروني",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "البريد الإلكتروني للدعم الفني",
        "PLACEHOLDER": "عنوان البريد الإلكتروني الخاص باستقبال رسائل الدعم الفني",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "عدد الأيام للتذكرة التي يجب أن يتم حلها تلقائياً إذا لم يكن هناك أي نشاط",
        "NOTE": "عدد ساعات عدم النشاط التي يتم بعدها حل أي محادثة مفتوحة تلقائياً.",
        "PLACEHOLDER": "30",
        "ERROR": "الرجاء إدخال مدة صالحة للحل تلقائي (حد أدنى 1 يوم والحد الأقصى 999 يوما)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "عدد الأيام التي يجب بعدها حل المحادثة الفارغة تلقائياً في حال عدم وجود أي نشاط",
        "PLACEHOLDER": "أبداً",
        "ERROR": "الرجاء إدخال مدة صالحة للحل التلقائي للمحادثات الفارغة (حد أدنى 1 يوم وحد أقصى 999 يوماً)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "الاستمرار في المحادثة عبر رسائل البريد الإلكتروني مفعّل لحسابك.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "يمكنك تلقي رسائل البريد الإلكتروني في النطاق المخصص الخاص بك الآن."
      },
      "PHONE": {
        "TITLE": "إعدادات PBX",
        "NOTE": "قم بتهيئة الاتصال بنظام PBX الخاص بك للمكالمات الهاتفية",
        "SIP_HOST": {
          "LABEL": "نطاق SIP"
        },
        "DIALING_MODE": {
          "LABEL": "وضع الاتصال",
          "MODES": {
            "direct": "مباشر - يتم الاتصال فوراً عند النقر على رابط الهاتف",
            "indirect": "غير مباشر - يُجهَّز رقم الهاتف في مربع إدخال أداة الهاتف"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "صلاحية الوصول إلى تسجيلات المكالمات",
          "MODES": {
            "admin_only": "المسؤولون فقط",
            "admin_and_assigned_agent": "المسؤولون والوكيل المكلَّف",
            "inbox_members": "جميع الوكلاء الذين لديهم صلاحية الوصول إلى صندوق الوارد"
          }
        }
      },
      "EMAIL": {
        "TITLE": "إعدادات البريد الإلكتروني",
        "NOTE": "يعدّل سلوك صناديق الوارد الخاصة بالبريد الإلكتروني"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "وضع عرض الطابع الزمني للمحادثة",
        "MODES": {
          "both": "وقت الإنشاء وآخر نشاط",
          "last_activity_only": "آخر نشاط فقط",
          "last_customer_message": "آخر رسالة من العميل"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "حظر النطاقات ذات السمعة المنخفضة"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "تضمين الرسالة الأصلية في الرد على البريد الإلكتروني"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "حل المحادثة الجديدة تلقائياً"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "نقل محادثة البريد الإلكتروني الجديدة تلقائيًا إلى صندوق الروبوت الذي عالج طلبات جهة الاتصال"
      },
      "EXTENDED_LABELS": {
        "LABEL": "الوسوم الموسّعة - السماح بأسماء وسوم أطول مع واجهة منبثقة أكبر"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - تعيين المحادثة تلقائياً للوكيل الذي كتب آخر رد"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "وضع الإشعارات الفورية",
        "MODES": {
          "all_inboxes": "جميع صناديق الوارد - إرسال إشعارات لجميع أنواع القنوات",
          "chat_only": "الدردشة فقط - إرسال إشعارات للقنوات غير البريد الإلكتروني فقط"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "السماح بتبديل التوقيع في الرسائل المرسلة"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "عرض حالة دردشة الوكيل على Wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "عرض أسماء المرفقات كاملة دون اختصار"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "تسجيل الدخول بكلمة المرور",
        "MODES": {
          "allowed_for_all": "مسموح لجميع المستخدمين",
          "allowed_for_agents_only": "مسموح للوكلاء فقط (يجب على المسؤولين استخدام OAuth)",
          "password_login_disabled": "معطّل - OAuth فقط"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "يتوفر إصدار جديد. أعد التحميل للحصول على آخر التحديثات.",
    "RELOAD_NOW": "تحديث الآن",
    "LEARN_MORE": "اعرف المزيد",
    "PAYMENT_PENDING": "الدفعة الخاصة بك معلقة. الرجاء تحديث معلومات الدفع الخاصة بك للاستمرار في استخدام هذا البرنامج",
    "LIMITS_UPGRADE": "لقد تجاوز حسابك حدود الاستخدام، يرجى ترقية خطتك للاستمرار في استخدام هذا البرنامج",
    "OPEN_BILLING": "فتح الفواتير"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "اضغط على زر الإدخال للاختيار",
      "ENTER_TO_REMOVE": "اضغط على زر الإدخال للحذف",
      "NO_OPTIONS": "القائمة فارغة",
      "NO_RESULT": "لم يتم العثور على نتائج",
      "SELECT_ONE": "اختر واحدا",
      "SELECT": "اختر"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "الإشعارات",
    "MARK_ALL_DONE": "وضع علامة منجز على الجميع",
    "DELETE_TITLE": "تم الحذف",
    "UNREAD_NOTIFICATION": {
      "TITLE": "إشعارات غير مقروءة",
      "ALL_NOTIFICATIONS": "عرض جميع الإشعارات",
      "LOADING_UNREAD_MESSAGE": "جار جلب الإشعارات الغير مقروءة...",
      "EMPTY_MESSAGE": "ليس لديك إشعارات غير مقروءة"
    },
    "LIST": {
      "LOADING_MESSAGE": "جاري جلب الإشعارات...",
      "404": "لا يوجد إشعارات",
      "TABLE_HEADER": [
        "الاسم",
        "رقم الهاتف",
        "المحادثات",
        "آخر تواصل"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "محادثة جديدة",
      "conversation_assignment": "تم تعيين المحادثة",
      "assigned_conversation_new_message": "رسالة جديدة",
      "participating_conversation_new_message": "رسالة جديدة",
      "conversation_mention": "إشارة",
      "sla_missed_first_response": "فشل اتفاقية مستوى الخدمة",
      "sla_missed_next_response": "فشل اتفاقية مستوى الخدمة",
      "sla_missed_resolution": "فشل اتفاقية مستوى الخدمة"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "غير متصل",
      "RECONNECTING": "جاري إعادة الاتصال...",
      "RECONNECT_SUCCESS": "تمت إعادة الاتصال"
    },
    "BUTTON": {
      "REFRESH": "تحديث"
    },
    "CONNECTION_LOST": {
      "TITLE": "انقطع الاتصال",
      "DESCRIPTION": "تعذّر الوصول إلى الخادم. تحقّق من اتصالك وحاول مرة أخرى.",
      "RETRY": "حاول مرة أخرى"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "البحث أو القفز إلى",
    "SECTIONS": {
      "GENERAL": "عام",
      "REPORTS": "التقارير",
      "CONVERSATION": "المحادثات",
      "BULK_ACTIONS": "الإجراءات الشاملة",
      "CHANGE_ASSIGNEE": "تغيير المحال إليه",
      "CHANGE_PRIORITY": "تغيير الأولوية",
      "CHANGE_TEAM": "تغيير الفريق",
      "SNOOZE_CONVERSATION": "تأجيل المحادثة",
      "EXECUTE_MACRO": "تنفيذ ماكرو",
      "ADD_LABEL": "إضافة وسم إلى المحادثة",
      "REMOVE_LABEL": "إزالة الوسم من المحادثة",
      "SETTINGS": "الإعدادات",
      "AI_ASSIST": "مساعدة AI",
      "APPEARANCE": "المظهر",
      "SNOOZE_NOTIFICATION": "تأجيل الإشعارات"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "الذهاب إلى لوحة المحادثة",
      "GO_TO_CONTACTS_DASHBOARD": "الذهاب إلى لوحة جهات الاتصال",
      "GO_TO_REPORTS_OVERVIEW": "الذهاب إلى نظرة التقارير العامة",
      "GO_TO_CONVERSATION_REPORTS": "الذهاب إلى تقارير المحادثات",
      "GO_TO_AGENT_REPORTS": "الذهاب إلى تقارير الوكيل",
      "GO_TO_LABEL_REPORTS": "انتقل إلى تقارير الوسم",
      "GO_TO_INBOX_REPORTS": "الذهاب إلى تقارير صندوق الوارد",
      "GO_TO_TEAM_REPORTS": "الذهاب إلى تقارير الفريق",
      "GO_TO_SETTINGS_AGENTS": "الذهاب إلى إعدادات الوكيل",
      "GO_TO_SETTINGS_TEAMS": "الذهاب إلى إعدادات الفريق",
      "GO_TO_SETTINGS_INBOXES": "الذهاب إلى إعدادات الصندوق الوارد",
      "GO_TO_SETTINGS_LABELS": "الذهاب إلى إعدادات الوسم",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "انتقل إلى إعدادات الردود الجاهزة",
      "GO_TO_SETTINGS_APPLICATIONS": "الذهاب إلى إعدادات التطبيق",
      "GO_TO_SETTINGS_ACCOUNT": "الذهاب إلى إعدادات الحساب",
      "GO_TO_SETTINGS_PROFILE": "الذهاب إلى إعدادات الملف الشخصي",
      "GO_TO_NOTIFICATIONS": "الذهاب إلى الإشعارات",
      "ADD_LABELS_TO_CONVERSATION": "إضافة وسم إلى المحادثة",
      "ASSIGN_AN_AGENT": "تعيين وكيل",
      "AI_ASSIST": "مساعدة AI",
      "ASSIGN_PRIORITY": "تعيين الأولوية",
      "ASSIGN_A_TEAM": "تعيين فريق",
      "EXECUTE_A_MACRO": "تنفيذ ماكرو",
      "MUTE_CONVERSATION": "كتم المحادثة",
      "UNMUTE_CONVERSATION": "إلغاء كتم المحادثة",
      "REMOVE_LABEL_FROM_CONVERSATION": "إزالة الوسم من المحادثة",
      "REOPEN_CONVERSATION": "إعادة فتح المحادثة",
      "RESOLVE_CONVERSATION": "حل المحادثة",
      "SEND_TRANSCRIPT": "إرسال نسخة نصية للبريد الإلكتروني",
      "SNOOZE_CONVERSATION": "تأجيل المحادثة",
      "UNTIL_NEXT_REPLY": "حتى الرد القادم",
      "UNTIL_NEXT_WEEK": "حتى الأسبوع القادم",
      "UNTIL_TOMORROW": "حتى الغد",
      "UNTIL_NEXT_MONTH": "حتي الشهر القادم",
      "AN_HOUR_FROM_NOW": "حتي ساعة من الأن",
      "UNTIL_CUSTOM_TIME": "مخصص...",
      "CHANGE_APPEARANCE": "تغيير المظهر",
      "LIGHT_MODE": "فاتح",
      "DARK_MODE": "مظلم",
      "SYSTEM_MODE": "النظام",
      "SNOOZE_NOTIFICATION": "تأجيل الإشعارات"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "جاري جلب تطبيق لوحة التحكم..."
  },
  "COMMON": {
    "OR": "أو",
    "CLICK_HERE": "اضغط هنا"
  }
}
